import { createSelector } from 'reselect';
import localeUtils from 'utils/LanguageLocale';

function isMultiStoreFilteringKillswitchEnabled() {
    const country = localeUtils.getCurrentCountry();
    const killswitchName = `sysMultiStoreFiltering${country}`;

    return Sephora.configurationSettings[killswitchName]?.isEnabled === true;
}

// TODO(rohit.gulati, 2026-06-02): Replace dummy with real A/B selector
const multiStoreFilteringAbTestSelector = createSelector(() => true);

const isMultiStoreFilteringEnabledSelector = createSelector(
    multiStoreFilteringAbTestSelector,
    multiStoreFilteringAbTest => isMultiStoreFilteringKillswitchEnabled() && multiStoreFilteringAbTest
);

export { isMultiStoreFilteringEnabledSelector };
